import React from 'react';
import PropTypes from 'prop-types';
import { UncontrolledTooltip } from 'reactstrap';

const stopHeaderAction = (event) => {
  event.preventDefault();
  event.stopPropagation();
};

const TableHeaderLabel = ({
  id,
  label,
  tooltip,
  as = 'p',
  tooltipClassName = 'lp-info-tooltip',
}) => {
  const Tag = as;

  if (!tooltip) {
    return <Tag>{label}</Tag>;
  }

  return (
    <Tag className="table-header-label">
      <span className="table-header-label__text">{label}</span>
      <button
        type="button"
        id={id}
        className="table-header-info-icon"
        aria-label={`${label} help`}
        onClick={stopHeaderAction}
        onMouseDown={stopHeaderAction}
      >
        ?
      </button>
<UncontrolledTooltip
  placement={
    tooltipClassName?.includes('lp-info-tooltip--with-image')
      ? 'bottom'
      : 'top'
  }
  target={id}
  container="body"
  delay={{ show: 100, hide: 200 }}
  innerClassName={tooltipClassName}
  modifiers={
    tooltipClassName?.includes('lp-info-tooltip--with-image')
      ? [{ name: 'flip', enabled: false }]
      : undefined
  }
>
  {tooltip}
</UncontrolledTooltip>
    </Tag>
  );
};

TableHeaderLabel.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  as: PropTypes.oneOf(['p', 'span']),
  tooltipClassName: PropTypes.string,
};

TableHeaderLabel.defaultProps = {
  tooltip: '',
  as: 'p',
  tooltipClassName: 'lp-info-tooltip',
};

export default TableHeaderLabel;
